module.exports = __webpack_public_path__ + "NoiseAware_GooglePlayStore9a905cb890cdaeebf00fca360c19abba.png";